<template>
  <widget :header="false" class="widget-judging-shortcuts island">
    <div class="shortcuts pal">
      <judging-shortcut
        v-if="permissions.canConfigureJudging"
        :url="routes['fast-start.index']"
        :action="lang.get('judging.dashboard.shortcuts.judging_fast_start')"
      />
      <judging-shortcut
        :url="routes['score-set.new']"
        :action="lang.get('judging.dashboard.shortcuts.score_set')"
      />
      <judging-shortcut
        :url="routes['panel.new']"
        :action="lang.get('judging.dashboard.shortcuts.panel')"
      />
      <judging-shortcut
        :url="routes['round.add']"
        :action="lang.get('judging.dashboard.shortcuts.round')"
      />
    </div>
    <div v-if="menu.length > 0" class="secondary-menu-submenu">
      <sub-menu
        id="judging-menu"
        :items="menu"
        @itemSelected="item => openLink(item.link)"
      />
    </div>
  </widget>
</template>

<script>
import $ from 'jQuery';
import Widget from '@/lib/components/Shared/Widget';
import JudgingShortcut from './JudgingShortcut';
import SubMenu from '@/lib/components/Navigation/SubMenu';

export default {
  inject: ['lang'],
  components: {
    Widget,
    JudgingShortcut,
    SubMenu
  },
  props: {
    routes: {
      type: Object,
      required: true
    },
    menu: {
      type: Array,
      default: () => []
    },
    permissions: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    openLink(url) {
      $.pjax({
        url: url,
        container: '#pjaxContainer',
        method: 'GET'
      });
    }
  }
};
</script>
